import { Injectable } from '@angular/core';
import { Angular2TokenService } from 'angular2-token';
import { RequestOptions } from '@angular/http';
import 'rxjs/Rx';

@Injectable()
export class FileUploadService {

  constructor(private tokenService: Angular2TokenService) { }

  uploadimagallery(formData) {
    const headers = this.tokenService.currentAuthHeaders;
    headers.delete('Content-Type');
    const options = new RequestOptions({ headers: headers });

    return this.tokenService.request({
      method: 'post',
      url: `https://www.saaristonsiirin.com/api/upload.php/imagegallery/images`,
      body: formData,
      headers: options.headers
    }).map(res => res.json());
  }

  uploadagility(formData, id) {
    const headers = this.tokenService.currentAuthHeaders;
    headers.delete('Content-Type');
    const options = new RequestOptions({ headers: headers });

    return this.tokenService.request({
      method: 'post',
      url: `https://www.saaristonsiirin.com/api/upload.php/agility/` + id,
      body: formData,
      headers: options.headers
    }).map(res => res.json());
  }

  uploadDog(formData, id) {
    const headers = this.tokenService.currentAuthHeaders;
    headers.delete('Content-Type');
    const options = new RequestOptions({ headers: headers });

    return this.tokenService.request({
      method: 'post',
      url: `https://www.saaristonsiirin.com/api/upload.php/dogs/` + id,
      body: formData,
      headers: options.headers
    }).map(res => res.json());
  }

  uploadshow(formData, id) {
    const headers = this.tokenService.currentAuthHeaders;
    headers.delete('Content-Type');
    const options = new RequestOptions({ headers: headers });

    return this.tokenService.request({
      method: 'post',
      url: `https://www.saaristonsiirin.com/api/upload.php/shows/` + id,
      body: formData,
      headers: options.headers
    }).map(res => res.json());
  }

  uploadPuppy(formData, id) {
    const headers = this.tokenService.currentAuthHeaders;
    headers.delete('Content-Type');
    const options = new RequestOptions({ headers: headers });

    return this.tokenService.request({
      method: 'post',
      url: `https://www.saaristonsiirin.com/api/upload.php/puppies/` + id,
      body: formData,
      headers: options.headers
    }).map(res => res.json());
  }

  uploadAnimal(formData, id) {
    const headers = this.tokenService.currentAuthHeaders;
    headers.delete('Content-Type');
    const options = new RequestOptions({ headers: headers });

    return this.tokenService.request({
      method: 'post',
      url: `https://www.saaristonsiirin.com/api/upload.php/animals/` + id,
      body: formData,
      headers: options.headers
    }).map(res => res.json());
  }

  upload(formData, id) {
    const headers = this.tokenService.currentAuthHeaders;
    headers.delete('Content-Type');
    const options = new RequestOptions({ headers: headers });

    return this.tokenService.request({
      method: 'post',
      url: `https://www.saaristonsiirin.com/api/upload.php/news/` + id,
      body: formData,
      headers: options.headers
    }).map(res => res.json());
  }
}



// WEBPACK FOOTER //
// C:/DEV/saaristonsiirin/src/app/file-upload.service.ts